{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description}}
{{/if}}
<div class="tool-field">
  <input type="text" placeholder="{{ config.placeholder }}" value="{{ context.text }}" />
</div>

<div class="preview buttons">
  <a href="" class="edit">Edit</a>
  <a href="" class="remove">Remove</a>
</div>

<div class="preview input-well tool-field">
  <span class="page-title">Loading...</span>
</div>

<div class="disable-inline"><button class="edit tool-button">Attach a Link</button></div>

<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
